import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Grid2 as Grid,
  Menu,
  MenuItem,
  IconButton,
  Slide,
  Stack,
} from '@mui/material';
import { MenuOutlined } from '@mui/icons-material';
import { WcedLogo } from '../../shared/components';
import { theme } from '../../app/themes/theme';
import { routeKeys, routeKeyPath } from '../../shared/utils/constants';

const TheMobileHeader = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState('Home'); // Track the active button

  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { aiLab, services, contactUs, forParents, forLearners, forTeachers } = routeKeyPath;

  const forTeachersMenu = [
    { title: 'Teacher', path: routeKeys.teachers },
    { title: 'Schools', path: routeKeys.admins },
    { title: 'Parents', path: routeKeys.parents },
    { title: 'Students', path: routeKeys.students },
  ];
  const forStudentsMenu = [
    { title: 'Teacher', path: routeKeys.teachers },
    { title: 'Schools', path: routeKeys.admins },
    { title: 'Parents', path: routeKeys.parents },
    { title: 'Students', path: routeKeys.students },
  ];

  type MenuItem = {
    title: string;
    path: string;
    variant?: 'text' | 'contained' | 'outlined';
  };

  const headerMenu: MenuItem[] = [
    { title: 'Home', path: '' },
    { title: 'Services', path: services },
    { title: 'For Teachers', path: forTeachers },
    { title: 'For Learners', path: forLearners },
    { title: 'For Parents/Guardians', path: forParents },
    { title: 'AI Tools', path: aiLab },
    { title: 'Contact Us', path: routeKeyPath.contactUs },
  ];
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenu(true);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenMenu(false);
  };
  const handleMenuItemClick = (path: string) => {
    navigate(path);
  };
  const toggleDrawer = (x: boolean) => {
    setOpenMenu(x);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const activeItem = headerMenu.find((item) => item.path === currentPath);
    if (activeItem) {
      setActiveIndex(activeItem.title);
    }
  }, [window.location.pathname]);

  return (
    <>
      <Slide in={showHeader} direction="down">
        <Grid
          container
          spacing={4}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            paddingTop: '15px',
            position: 'sticky', // Sticky to the top
            top: 0,
            backgroundColor: '#fff',
            zIndex: 3,
          }}
        >
          <Grid size={8} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <WcedLogo width="170px" />
          </Grid>
          <Grid
            size={4}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: '10vw' }}
          >
            <IconButton onClick={() => toggleDrawer(true)}>
              <MenuOutlined />
            </IconButton>
          </Grid>
        </Grid>
      </Slide>
      <Drawer anchor="right" open={openMenu} onClose={() => toggleDrawer(false)}>
        <Stack sx={{ width: 150 }}>
          <List>
            {headerMenu.map((item, index) => (
              <ListItem
                key={index}
                onClick={() => {
                  navigate(item.path);
                  setActiveIndex(item.title);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  toggleDrawer(false);
                }}
                sx={{
                  background: activeIndex === item.title || item.path === window.location.pathname ? '#007DBA' : '', // Active button background color
                  color: activeIndex === item.title || item.path === window.location.pathname ? '#fff' : 'primary',
                }}
              >
                <ListItemButton>
                  <ListItemText primary={item.title} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Stack>
      </Drawer>
    </>
  );
};

export default TheMobileHeader;
